import React, { type ReactElement } from 'react';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import PageHeader from '@atlassian/jira-common-components-page-header/src/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type {
	IntlShapeV2 as IntlShape,
	MessageDescriptorV2 as MessageDescriptor,
} from '@atlassian/jira-intl/src/v2/types.tsx';

type Props = {
	title?: MessageDescriptor;
	breadcrumbs: ReactElement;
	intl: IntlShape;
	actions?: ReactElement;
};

const Header = ({ title, breadcrumbs, intl: { formatMessage }, actions }: Props) => (
	<>
		<PageHeader truncateTitle breadcrumbs={breadcrumbs} />
		<Box xcss={titleContainer}>
			<Box>
				<Heading size="large" as="h1">
					{title && formatMessage(title)}
				</Heading>
			</Box>
			{actions && <Box>{actions}</Box>}
		</Box>
	</>
);

export default injectIntl(Header);

const titleContainer = xcss({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'flex-end',
});
